import { makeStyles } from '@mui/styles';

import React, { useState, useContext, useRef } from 'react';

import FormGroup from '../FormGroup';

import axios from '../../../common/AxiosConfig';

import { AppContext } from '../../../../RoutesWithAuth';

import { useNavigate } from "react-router-dom";

import { v2UIRoutePath } from '../../../common/commons';

import Dialog from '../Dialog';
import { Button, Box } from '@mui/material';
import { standardButtonStyle, cancelButtonStyle } from './buttonStyles';
const CANCELLED_STATUS_WARNING = 'This action will cancel this request in CPS and will not be send to downstream or upstream systems. Click Submit again to confirm and proceed';
const DELETED_STATUS_WARNING = 'This action will delete this request from CPS permanently and this action cannot be revoked. Click Submit again to confirm and proceed';

const useStyles = makeStyles(() => ({
    dialogPaper: {
        width: '600px',
        maxWidth: '90%',
    },
    dialogTitle: {
        background: 'linear-gradient(135deg, #1e3a5f 0%, #267db7 125%, #3b9edd 100%)',
        color: '#fff',
        padding: '16px 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    titleText: {
        fontSize: '1.1rem',
        fontWeight: 600,
        letterSpacing: '0.3px',
    },
    formWrapperClassName: {
        paddingTop: '20px',
        '& .checkboxcmp' :{
            paddingLeft : "25px"
        },
        '& .checkboxcmp label' :{
            width : '45% !important'
        },
        '& label': {
            display: "inline-block",
            width: "150px !important"
        },
        '& .MuiFormControl-fullWidth': {
            width: "50%"
        }
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        gap: '12px',
        paddingTop: '20px',
        paddingBottom: '10px',
    }
}));

const StatusUpdate = ({
    hideComponent,
    isLoading,
    data,
    dsarRequestId,
    setDisplayErrMsg,
    setDisplaySuccessMsg,
    setIsLoading
}) => {
    const [formValidation, setFormValidation] = useState("");
    const [formData, setFormData] = useState({});
    const formGroupRef = useRef();
    const context = useContext(AppContext)
    const authToken = context.authToken.get;
    const loggedInUserId = context.userId.get;
    const setReloadHealth = context.reloadHealth.set;

    const navigate = useNavigate();

    const classes = useStyles();
    const currentStatus = data?.status || "";
    const getStatusOptions = () => {
        let options = [];
        if (currentStatus === "Pre Open"){
            options = ["Cancelled", "Deleted"]
        } else if(currentStatus === "Open") {
            options = ["Pre Open","Cancelled", "Deleted"]
        } else if (currentStatus === "Cancelled") {
            options =  ["Deleted"]
        } else if (["Closed", "Review", "Uploaded", "Upload Failed"].findIndex((rec)=>rec===currentStatus) !== -1) {
            options = ['Cancelled', 'Closed', 'Deleted', 'Review', 'Uploaded', 'Upload Failed'];
        }
        options = options.filter((data)=>data !== currentStatus);
        return options;
    }
    const handleClearForm = () => {
        setFormValidation("");
        formGroupRef.current?.resetFormToDefaults();
    }
    const handleFormSubmit = () => {
        if (formData) {
            if (!formData.status || !formData.reason || (formData.comments || "").length < 10) {
                setFormValidation("Status, Update Reason and minimum 10 character comments are mandatory for status update");
            } else if ((formData.comments || "").includes(":")) {
                setFormValidation(" ':' character is not allowed in comments");
            } else {
                setFormValidation("");
                preCheckProcessStatusUpdate(formValidation, formData);
            }
        }
    }
    const preCheckProcessStatusUpdate = (currentError, formValues) => {
        if (formValues.status === "Cancelled" && currentError !== CANCELLED_STATUS_WARNING) {
            setFormValidation(CANCELLED_STATUS_WARNING);
        } else if (formValues.status === "Deleted" && currentError !== DELETED_STATUS_WARNING) {
            setFormValidation(DELETED_STATUS_WARNING);
        } else {
            processStatusUpdate(formValues)
        }
    }
    const processStatusUpdate = (formValues) => {
        let api = '/ticket/update_status';
        let payload = {
            "dsar_id": dsarRequestId,
            "status": formValues.status,
            "cancellation_reason": formValues.reason,
            "cancellation_reason_other": formValues.comments,
            "userId": loggedInUserId
        }
        if (formValues.status === "Deleted") {
            api = "/delete_request";
            payload = {
                dsar_id: dsarRequestId,
                reason: formValues.reason,
                comments: formValues.comments
            }
        }
        if(formValues.status === "Closed"){
            payload["reconsolidatecheck"] = formValues.reconsolidatedCheck;
        }
        setIsLoading(true);
        axios.post(api, payload, {
            headers: {
                Authorization: authToken,
            },
        }).then((res) => {
            setIsLoading(false);
            setDisplaySuccessMsg("Status Update is completed");
            setTimeout(() => {
                hideComponent(true);
                setReloadHealth(Math.round(Math.random() * 1e5));
                if(formValues.status === "Deleted"){
                    navigate(v2UIRoutePath + "");
                }
            }, 300);

        }).catch((err) => {
            setIsLoading(false);
            if (err?.response?.data?.message) {
                setDisplayErrMsg(err.response.data.message)
            }
        });
    }
    return (
        <Dialog
        isOpen={true}
        updateDialogStatus={() => {
            hideComponent(false);
        }}
        customWidth="600px"
        customHeight="auto"
        dialogTitleClassName={classes.dialogTitle}
        isForm={true}
        isLoading={isLoading}
        dialogContent={
            <>
                <FormGroup
                    ref={formGroupRef}
                    formWrapperClassName={classes.formWrapperClassName}
                    refreshGridWithSearch={handleFormSubmit}
                    handleClearForm={handleClearForm}
                    formError={formValidation}
                    disableFormActions={true}
                    customFormUpdates={(updatedFormData) => setFormData(updatedFormData)}
                    fields={[
                        {
                            type: 'multiselect',
                            name: 'status',
                            label: 'Select Status :',
                            isMulti: false,
                            placeholder: "Select Status",
                            options: getStatusOptions(),
                            size: 12,
                            removeCheckBox: true,
                        }, {
                            type: 'multiselect',
                            name: 'reason',
                            label: 'Update Reason :',
                            isMulti: false,
                            size: 12,
                            placeholder: "Select Update Reason",
                            removeCheckBox: true,
                            options: ['Duplicate request created by TIPS', 'Manual review completed', 'Test request', 'Other'],
                        }, {
                            type: 'text',
                            name: 'comments',
                            label: 'Comments :',
                            size: 12
                        },{
                            type : 'checkbox',
                            name : 'reconsolidatedCheck',
                            label : 'Re-Consolidate upstream response',
                            defaultOption : true,
                            hiddenCallback : (formData)=>{
                                return !(formData && formData.status === "Closed");
                            },
                            size :12,
                            customInputCls : "checkboxcmp"
                        }
                    ]}
                />
                <Box className={classes.buttonContainer}>
                    <Button
                        variant="contained"
                        onClick={() => hideComponent(false)}
                        sx={cancelButtonStyle}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleClearForm}
                        sx={cancelButtonStyle}
                    >
                        Clear
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleFormSubmit}
                        sx={standardButtonStyle}
                    >
                        Submit
                    </Button>
                </Box>
            </>
        }
        title={<span className={classes.titleText}>Status update</span>}
    />
      
    )
}
export default StatusUpdate;